module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-30acce0e.png";